// extracted by mini-css-extract-plugin
module.exports = {"root":"index_root_2asSS","wide":"index_wide_2jRcK"};